import React from "react";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import Pricing from '../../layouts/auth/types/Pricing';

function EventCalendar(props: {
  calendarData: {
    title: string;
    name: string;
    email: string;
    border?: string;
    start: string;
    end?: string;
    backgroundColor: string;
    className?: string;
    details?:{
      title:  string,
      day:  string,
      weekday: string,
      hours: string
    }
  }[];
  initialDate: string;
  handleDateClick: any;
}) {

  const { calendarData, initialDate, handleDateClick } = props;

 
  const handleEventClick = (clickInfo:any) => {
    };
  const renderEventContent = (eventInfo:any) => {
    return (
      <div style={{
        backgroundColor: '#ffffff', // White background for the card
        color: '#333333', // Darker text for better readability
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)', // Slight shadow for depth
        borderRadius: '4px', // Rounded corners
        margin: '5px',
        padding: '10px',
        display: 'flex',
        flexDirection: 'column', // Stack content vertically
        justifyContent: 'center', // Center content vertically
        alignItems: 'start', // Align content to start horizontally
      }}>
        <div style={{ fontWeight: 'bold' }}>
          {eventInfo.event.title}
        </div>
      </div>
    );
  };

  return (
    
    <FullCalendar
    events={calendarData}

    plugins={[dayGridPlugin, interactionPlugin]}
    initialView="dayGridMonth"
    headerToolbar={{
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth'
    }}
    editable={true}
    selectable={true}
    selectMirror={true}
    dayMaxEvents={true}
    dateClick={handleDateClick}
    eventClick={handleEventClick}
    eventContent={renderEventContent}

/>
  );
}

export default EventCalendar;
